import { Button, Card, CardHeader, CardContent, Typography, Grid } from '@mui/material';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { useParams } from 'react-router-dom';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  buttonStyle: { height: '42px' },
};

interface FeatureSetupPage {
  openNoteDialog: () => void;
  openPlanDialog?: () => void;
  openProjectDocumentDialog?: () => void;
}

interface ComponentCell {
  openNoteDialog: () => void;
  openPlanDialog?: () => void;
  openProjectDocumentDialog?: () => void;
}

const ComponentCell = ({ openNoteDialog, openPlanDialog, openProjectDocumentDialog }: ComponentCell) => {
  const { projectID } = useParams();
  return (
    <Grid container spacing={1}>
      {projectID && (
        <>
          {/* <Grid item>
            <Button fullWidth variant="outlined" onClick={openPlanDialog} style={styling.buttonStyle}>
              PROJECT PLANS
            </Button>
          </Grid> */}
          <Grid item>
            <Button fullWidth variant="outlined" onClick={openProjectDocumentDialog} style={styling.buttonStyle}>
              PROJECT DOCUMENTS/FILES
            </Button>
          </Grid>
        </>
      )}
      <Grid item>
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_NOTE]}>
          <Button fullWidth variant="outlined" onClick={openNoteDialog} style={styling.buttonStyle}>
            NOTES
          </Button>
        </GuardedComponent>
      </Grid>
      {/* <Grid item lg={2} sm={2} xl={2} xs={2}>
        <SelectFieldDynamic
          name="projectStatusID"
          label="Status"
          getQueryKeyConfig={() => projectsApiKeyStore.getProjectStatus()}
          optionsLabelKeys={['projectStatus']}
          optionsValueKey="projectStatusID"
        />
      </Grid> */}
      {/* <Grid item style={{ marginLeft: 'auto' }}>
        <Grid container direction="row" justifyContent="flex-end" alignItems="flex-start">
          <FormCheckbox label="Rebate required" name="rebate" />
        </Grid>
      </Grid> */}
    </Grid>
  );
};

export const FeaturesSetup = ({ openNoteDialog, openPlanDialog, openProjectDocumentDialog }: FeatureSetupPage) => {
  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary">
            SETUP
          </Typography>
        }
      ></CardHeader>
      <CardContent>
        <ComponentCell
          openNoteDialog={openNoteDialog}
          openPlanDialog={openPlanDialog}
          openProjectDocumentDialog={openProjectDocumentDialog}
        />
      </CardContent>
    </Card>
  );
};
